import { IsNotEmpty, IsOptional } from "class-validator";

import { EventRegistrationCreateDto } from "./event-registration-create.dto";

export class EventRegistrationByClubManagerCreateDto extends EventRegistrationCreateDto {
  // @IsNotEmpty()
  // owner_id: string;

  @IsOptional()
  payment_method_id?: string; // saved club's card
}
